/*
  sp-cart-redirect.js (product template only)
  Legacy behaviour: about 2 seconds after the product page add button is clicked, go to the cart page.
  Here: after a SUCCESSFUL add from the main product form (the sticky bar clicks the main button,
  so it takes the same path), wait 2 seconds and navigate to routes.cart_url.
  Quick-add / recommendation forms and failed adds do nothing.
*/
(function () {
  'use strict';

  if (window.__spCartRedirect) return;
  window.__spCartRedirect = true;

  var DELAY = 2000;
  var pending = false;
  var timer = null;

  function isMainProductForm(form) {
    if (!form || !form.closest || !form.closest('product-form')) return false;
    if (form.closest('quick-add-modal, product-recommendations, [data-sp-no-cart-redirect]')) return false;
    return !!form.closest('#MainContent');
  }

  // Capture phase: runs before Dawn's own submit handler on the form.
  document.addEventListener(
    'submit',
    function (event) {
      pending = isMainProductForm(event.target);
    },
    true
  );

  function start() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!pending || !event || event.source !== 'product-form') return;
      pending = false;
      clearTimeout(timer);
      timer = setTimeout(function () {
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      }, DELAY);
    });

    subscribe(PUB_SUB_EVENTS.cartError, function () {
      pending = false;
      clearTimeout(timer);
    });
  }

  start();
})();
